module.exports = __webpack_public_path__ + "img/x02.dd90c522.png";